var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"header"}},[_c('div',{staticClass:"container h-100"},[_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col-md-2 align-self-center logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo-image",attrs:{"src":"public/images/logo.png","alt":"Vida Más Salud"}})])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }